export default{name:"miniloader"};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/miniloader.vue
// module id = 270
// module chunks = 0